import { ChevronDownSolid } from '@allocab/allocab-icons';
import { Listbox } from '@headlessui/react';
import clsx from 'clsx';
import { Key } from 'react';

type Props<T> = {
  items: T[];
  selectedItem: T | null;
  renderButton: (_item: T | null) => string;
  renderItem: (_item: T) => string;
  keyExtractor: (_item: T) => Key;
  onItemSelected: (_item: T) => void;
  alignment?: 'left' | 'right';
};

export const Dropdown = <T extends object | string | number>({
  items,
  selectedItem,
  renderItem,
  keyExtractor,
  renderButton,
  onItemSelected,
  alignment = 'left',
}: Props<T>) => {
  return (
    <Listbox value={selectedItem} onChange={onItemSelected} as="div" className="relative inline-block ">
      <Listbox.Button className="max-w-[224px] relative w-full cursor-default rounded-md bg-background py-1.5 pl-3 pr-10 text-left shadow-sm shadow-shadow ring-1 ring-inset ring-border focus:outline-none focus:ring-2 focus:ring-cta sm:text-sm sm:leading-6">
        <span className="block truncate"> {renderButton(selectedItem)}</span>
        <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
          <ChevronDownSolid height={12} width={12} className="fill-text_secondary" aria-hidden="true" />
        </span>
      </Listbox.Button>
      <Listbox.Options
        className={clsx(
          alignment === 'right' && 'right-0',
          'absolute z-10 mt-1 max-h-60 w-56 overflow-auto rounded-md bg-background py-1 text-base shadow-lg shadow-shadow ring-1 ring-border ring-opacity-5 focus:outline-none sm:text-sm',
        )}
      >
        {items.map(item => (
          <Listbox.Option
            key={keyExtractor(item)}
            value={item}
            as="button"
            className="truncate px-2 py-1 w-full text-left"
          >
            {renderItem(item)}
          </Listbox.Option>
        ))}
      </Listbox.Options>
    </Listbox>
  );
};
